export const GALLERY_IMAGES_QUERY = `
  query GalleryImages($locale: LocaleInputType, $where: GalleryImage_where, $limit: Int, $page: Int) {
    GalleryImages(where: $where, locale: $locale, limit: $limit, page: $page) {
      docs {
        id
        title
        image {
          id
          url
          alt
          filename
          width
          height
          updatedAt
          createdAt
        }
        useCases {
          id
          label
        }
        products {
          id
          label
        }
        createdAt
        updatedAt
      }
      totalDocs
      totalPages
      page
      hasNextPage
      hasPrevPage
    }
  }
`;

export const VIDEOS_QUERY = `
  query Videos($locale: LocaleInputType, $where: Video_where, $limit: Int, $page: Int, $sort: String) {
    Videos(where: $where, locale: $locale, limit: $limit, page: $page, sort: $sort) {
      docs {
        id
        title
        videoUrl
        useCases {
          id
          label
        }
        products {
          id
          label
        }
        hideVideo
        createdAt
        updatedAt
      }
      totalDocs
      totalPages
      page
      hasNextPage
      hasPrevPage
    }
  }
`;
